import {SET_STEP,SET_IS_SUBSCRIBING} from "../actions/types"


const initialState = {
    currentStepIndex: parseInt(localStorage.getItem("currentStepIndex") || "0", 10),
    isInRegistration: false,
    isSubscribing: localStorage.getItem("isSubscribing") === "true",
    steps:[]
  };
  
  const registrationStepReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
      case SET_STEP:
        localStorage.setItem("currentStepIndex", payload.step);
        return {
          ...state,
          currentStepIndex: payload.step,
          isInRegistration:payload.status
        };
        case SET_IS_SUBSCRIBING:
          localStorage.setItem("isSubscribing", payload.isSubscribing);
          return {
            ...state,
            isSubscribing: payload.isSubscribing,
            steps: payload.isSubscribing
              ? [
                  "/terms-and-condition",
                  "/register-basic-info",
                  "/register-tenant-profile",                
                  "/register-rental-profile",
                 
                ]
              : [
                  "/terms-and-condition",
                  "/register-basic-info",
                  "/register-tenant-profile",
                  "/register-rental-profile",
              
                ],
          };
      default:
        return state;
    }
  };
  export default registrationStepReducer;